import { Set } from 'immutable';
import {flatProductList} from "@ignitesales/neuro-application";

/**
 * Take products recommendations and product cart IDs and puts
 * together a map of actual recommendations that are in the cart
 *
 * @param productCart
 * @param productRecommendations
 * @returns {*}
 */
  //TODO: move to neuro utilities
const filterCartProductsByRecs = (productCart, productRecommendations) => {
  const productList = flatProductList(productRecommendations);
  const productsInCart = productList.filter(p => (productCart || new Set()).has(p.id.toString()));

  let addOnProductsInCart = new Set();
  productsInCart.filter(p => (p.addOns || []).length).forEach(p => {
    p.addOns.forEach(addOn => {
      if ((productCart || new Set()).has(addOn.id.toString())) {
        addOn.groupType = p.groupType;
        addOnProductsInCart = addOnProductsInCart.add(addOn);
      }
    });
  });

  return productsInCart.concat(addOnProductsInCart.toArray());
};

export default filterCartProductsByRecs;
